import styled from 'styled-components'

export const GamingContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 70px;
  margin-left: 270px;
  background-color: ${props => (props.theme === true ? '#0f0f0f' : '#f9f9f9')};
  @media screen and (max-width: 767px) {
    width: 100%;
    margin-left: 0px;
    margin-top: 50px;
  }
`
export const GamingHeader = styled.nav`
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 130px;
  padding: 30px;
  background-color: ${props => (props.theme === true ? '#181818' : '#ebebeb')};
  @media screen and (max-width: 767px) {
    height: 80px;
    padding: 10px;
  }
`

export const GamingIconContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 65px;
  width: 65px;
  border-radius: 50%;
  margin-right: 12px;
  background-color: ${props => (props.theme === true ? '#0f0f0f' : '#d7dfe9')};
  @media screen and (max-width: 767px) {
    height: 35px;
    width: 35px;
  }
`

export const GamingIcon = styled.i`
  height: 23px;
  width: 23px;
  @media screen and (max-width: 767px) {
    height: 13px;
    width: 13px;
  }
`

export const GamingPara = styled.p`
  font-size: 28px;
  align-self: center;
  font-family: 'Roboto';
  font-weight: 800;
  color: ${props => (props.theme === true ? '#f4f4f4' : '#424242')};
  @media screen and (max-width: 767px) {
    font-size: 18px;
  }
`

export const GamingVideos = styled.ul`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  list-style: none;
  width: 100%;
  background: transparent;
`

export const GamingVideoCardContainer = styled.li`
  list-style-type: none;
  display: flex;
  flex-direction: column;
  width: 230px;
  margin: 0px;
  margin-bottom: 20px;
  text-decoration: none;
  @media screen and (max-width: 576px) {
    padding: 10px;
    width: 200px;
  }
`
export const GamingImgContainer = styled.div`
  width: 220px;
  margin-right: 10px;
  height: 380px;
  @media screen and (max-width: 767px) {
    width: 180px;
    height: 230px;
    margin: 0px;
  }
`
export const GamingVideoCardThumnailImg = styled.img`
  height: 100%;
  width: 100%;
`

export const GamingVideoCardTitle = styled.p`
  font-family: 'Roboto';
  font-weight: 800;
  font-size: 22px;
  margin: 5px;
  color: ${props => (props.theme === true ? '#f4f4f4' : '#181818')};
`

export const GamingVideoCardViewCount = styled.p`
  font-family: 'Roboto';
  font-size: 16px;
  color: #424242;
  margin: 4px;
  text-decoration: none;
`
